<template>
  <div class="overall-bg">
    <b-container>
      <b-row v-if="tstatus == true">

        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout :headertext="$t('Supppliers.SupppliersMaster.Master')"
            :contenttext="$t('Supppliers.SupppliersMaster.content')">
          </Headerlayout>
        </b-col>
      </b-row>

      <b-row class="py-5">
        <Loader :loading="loading" />
        <div v-if="!loading">
          <MasterEmpty :createline="false" v-if="items.length === 0" eheader="Item Store Mapping"
            econtent="Item Store Mapping" eimg="/src/assets/Img/icons/itemmaster.svg" @createNew="IsCreate" />
          <Tableview v-if="items.length !== 0" :value="items" :paginator="true" class="p-datatable-gridlines" :rows="10"
            :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="headers"
            :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single" @row-click="RowClick">
            <template v-slot:Add>
              <!-- <span class="add">
                <AddButton @click="IsCreate()" :btnname=" $t('btn.plusaddnew')" class="float-rights my-3"></AddButton>
              </span> -->
            </template>
            <template v-slot:action="{ data }">
              <span>
                <EditIcon @click="Editdata(data)" class="me-3" />
                <DeleteIcon @click="Deletedata(data)" />
              </span>
            </template>
          </Tableview>
        </div>
      </b-row>

      <DeletedSuccessfully :visible="deletepop" @ok="deletepop = false" />
      <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete()" @no="Deletemodel = false" />
      <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit()" @no="Editmodel = false"
        :content="$t('confirmation.editcontent')" />
    </b-container>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, h, onMounted, computed, watch } from "vue";

import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";


import service from "../../../../../modules/Inventory/Service/SupplierMaster";
import Table from "../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../components/FormComponents/DeletedSuccessfully.vue";
import SupplierCategoryMappingService from '../../../../../modules/Inventory/Service//SupplierCategoryMappingService'
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import Loader from '../../../../../components/FormComponents/Loader.vue'

export default defineComponent({
  components: {


    Table,
    Tableview,
    DeletedSuccessfully,
    EditConfirmation,
    DeleteConfirmationVue,
    MasterEmpty,
    Loader
  },
  props: {
    tstatus: {
      default: true,
      type: Boolean
    }
  },
  setup() {

    const Editmodel = ref(false);
    const { t } = useI18n();
    const router = useRouter();
    const routers = useRoute();

    const generic = ref();

    let loading1 = ref(false);
    const ParamValues = ref({
      itemid: 0,
      itemcategoryid: 0,
    });
    //Loading
    let loading = ref(false);
    let supplierid = 0;

    const deletepop = ref(false);
    const Deletemodel = ref(false);
    let itemid = routers.query.id;
    let itemcategoryid = routers.query.itemcategoryId

    ParamValues.value.itemid = Number(itemid);
    ParamValues.value.itemcategoryid = Number(itemcategoryid);
    watch(
      () => routers.query.id,
      (newVal: any) => {
        // alert(routers.query.id)
        // alert(routers.query.itemcategoryId)
        ParamValues.value.itemid = Number(routers.query.id);
        ParamValues.value.itemcategoryid = Number(routers.query.itemcategoryId);
        // alert(ParamValues.value.itemcategoryid)
        debugger;

        // ParamValues.value.itemid = Number(newVal)
        // ParamValues.value.itemcategoryid = Number(newVal)
        IsShow()
      }
    );


    function Editdata(data) {
      supplierid = data.Id;
      Editmodel.value = true;
    }

    function Deletedata(data) {
      supplierid = data.Id;
      Deletemodel.value = true;
    }
    onMounted(() => {
      IsShow();
    });
    // filters for datatable

    const items = ref([]);

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: { value: null, matchMode: FilterMatchMode.IN, options: items },
      SupplierCategory: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const headers = [
      {
        header: "Supplier ID",
        field: "Code",
      },
      {
        header: "Supplier Name",
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: 'boldclass',
      },
      // {
      //   field: "action", header: "Action", slot: "action",
      //   frozencolumn: true, sortable: false
      // },
    ];

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));

    // add new button function

    const IsCreate = () => {
      router.push({
        path: "/SupplierMasterCreation",
      });
    };

    // edit button function

    function IsEdit() {
      router.push({
        path: "/SupplierMasterCreation",
        query: {
          Id: supplierid,
        },
      });
    }

    // row click for table

    function RowClick(event: any) {
      // console.log(event.data)
      debugger;

      // rowFocus.value = true;
      // Editmodel.value = true;
      // supplierid = event.data.Id;
      router.push({
        path: '/SupplierMasterDetailsView',
        query: {
          Id: event.data.Id,
          Type: 'SupplierId'
        }
      })
    }

    //Get data for table

    async function IsShow() {
      loading.value = true
      debugger;
      //const itemid1 = await ItemMasterService.Edit(ParamValues.value.itemid)
      //const itemcatid1 = itemid1['result'].ItemTypeId
      const itemcatid1 = ParamValues.value.itemcategoryid
      console.log(itemcatid1)
      debugger;
      const result1 = await SupplierCategoryMappingService.suppliercategorymappinglist();
      debugger;
      let datas = result1['result'].filter((item) => itemcatid1 == item.ItemCategoryId);
      console.log(datas)
      const result = await service.gettable();
      console.log(result);
      items.value = result['result'].filter((val) => datas.some((item) => item.SupplierId == val.Id));
      console.log(items.value)
      loading.value = false
    }

    //Delete Values in Table

    const IsDelete = async () => {
      try {
        const response = await service.deletedata(supplierid);
        Deletemodel.value = false;
        IsShow();
        deletepop.value = true;
      } catch (error) {
        console.log(error);
      }
    };

    const dataEdit = ref();
    const rowFocus = ref(false);
    const showDialog = ref();

    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false
      ) {
        // IsEdit(dataEdit.value)
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsCreate();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit();
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      }
    }

    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });

    return {
      deletepop,
      headers,
      items,
      IsShow,
      IsDelete,
      generic,
      loading1,
      globalFilterFields,
      filters,
      IsCreate,
      IsEdit,
      Editdata,
      Editmodel,
      Deletedata,
      RowClick,
      Deletemodel,
      ParamValues,
      loading
    };
  },
});
</script>
